/* eslint-disable no-mixed-operators */

import React, { useEffect } from 'react';

// import SwensensLogo from './SwensensLogo';
import { MembershipCardRow } from './MembershipCard';

import SwensensHR from './SwensensHR';

import CoolRewardsJuniorView from './CoolRewardsJuniorView';
import RebatePointsView from './RebatePointsView';
import TierStatusProgress from './TierStatusProgress';
import VouchersView from './VouchersView';
import KidsView from './KidsView';

import UpdateProfileAndAddChildButtons from './UpdateProfileAndAddChildButtons';

import TelegramAppForMobileWithConfigProblem from './TelegramAppForMobileWithConfigProblem';
import DebugAndTestingElements from './DebugAndTestingElements';

import { parseMemberData } from './utils';
import { VerticalSeparator } from './utils';

export function TelegramAppForMobileConfigured({ token, memberData, clearAppSecret = null, updateMemberData = null }) {
    const { name, tierCode, cardId, cardInfo, membershipInfo } = parseMemberData(memberData);

    useEffect(() => {
        if (window?.Telegram?.WebApp) {
            setTimeout(() => {
                window.Telegram.WebApp.expand();
            }, 250)
        }
    }, [])

    useEffect(() => {
        console.log('[Member Data] Member data will be automatically updated periodically.');
        const interval = setInterval(() => {
            if (!!updateMemberData) {
                console.log('[Member Data] Attempting to update member data...');
                updateMemberData();
            }    
        }, 10 * 60 * 1000);    
        return () => {
            console.log('[Member Data] Member data will no longer be automatically updated.');
            clearInterval(interval);
        }    
    }, [updateMemberData]);    

    return (
        <div>
            <div style={{ width: '360px', paddingLeft: '10px', paddingRight: '10px', fontSize: '1em' }}>
                
                {/* <SwensensLogo/> */}

                <VerticalSeparator height='30px'/>

                <div style={{ width: '340px' }}>
                    {
                        cardInfo && membershipInfo ? (
                            <div>
                                <MembershipCardRow
                                    name={name}
                                    cardId={cardId}
                                    tierCode={tierCode}
                                />
                                
                                {
                                    tierCode === 'Cool Rewards Junior' ? (
                                        <CoolRewardsJuniorView
                                            memberData={memberData}
                                        />
                                    ) : (
                                        <>
                                            <RebatePointsView
                                                memberData={memberData}
                                            />

                                            <SwensensHR/>

                                            <VouchersView
                                                memberData={memberData}
                                                token={token}
                                                updateMemberData={updateMemberData}
                                            />

                                            <KidsView
                                                memberData={memberData}
                                                token={token}
                                                updateMemberData={updateMemberData}
                                            />

                                            <TierStatusProgress
                                                memberData={memberData}
                                            />

                                            <VerticalSeparator height='2em'/>

                                            {
                                                memberData?.__member_record__ && (
                                                    <>
                                                        <UpdateProfileAndAddChildButtons
                                                            memberData={memberData}
                                                            token={token}
                                                            updateMemberData={updateMemberData}
                                                        />

                                                        <VerticalSeparator height='1em'/>
                                                    </>
                                                )
                                            }
                                        </>
                                    )
                                }
                            </div>
                        ) : (
                            <TelegramAppForMobileWithConfigProblem clearAppSecret={clearAppSecret}/>
                        )
                    }
                </div>
            </div>

            <DebugAndTestingElements token={token} memberData={memberData}/>

            <VerticalSeparator height='2em'/>
        </div>
    );
}
